module.exports = __webpack_public_path__ + "img/icon-event-management.ef832508.png";